import { compose } from 'redux';
import { connect } from 'react-redux';
import { withReducer } from '../../withReducer';
import { withSettings } from '../withSettings';
import { reducer } from '../reducer';
import { mapDispatchToProps } from '../container';
import { ImagePreview } from './preview';
const mapStateToProps = (state, props) => {
    return {
        ...state[props.componentIdent],
        isChecked: !state[props.componentIdent].isHidden,
    };
};
export const ImagePreviewContainer = compose(withReducer(reducer), connect(mapStateToProps))(ImagePreview);
export const ImageFormContainer = compose(withReducer(reducer), connect(mapStateToProps, mapDispatchToProps))(withSettings());
//# sourceMappingURL=container.js.map